<template>
    <div class="amazonKey-leftmenu-main-container">
        <div class="amazonKey-goback-wrapper" @click="goBack">
            <i class="fa-solid fa-arrow-left" />
            <p>{{ getGoBackTitle }}</p>
        </div>
        <div class="amazonKey-infos-wrapper">
            <div class="amazonKey-name-wrapper">
                <i class="fa-solid fa-bookmark" />
                <p>{{ $t("amazonKey.title") }}</p>
            </div>
            <img :src="require('@/assets/images/amazonKey/logo.svg')" alt="" />
        </div>
        <div class="tab-options-wrapper">
            <div
                class="tab-options"
                :class="selectedTabs === 'details' ? 'selected-tab' : ''"
                @click="selectTab('details')"
            >
                <i class="fa-solid fa-circle-info"></i>
                <p>{{ $t("amazonKey.details.title") }}</p>
            </div>
            <div
                class="tab-options"
                :class="selectedTabs === 'events' ? 'selected-tab' : ''"
                @click="selectTab('events')"
            >
                <i class="fa-solid fa-diagram-cells"></i>
                <p>{{ $t("accessCard.events") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectedTabs: "details",
        }
    },

    computed: {
        breadCrumb() {
            return this.$store.getters["breadCrumb/getClassicBreadCrumb"]
        },

        getGoBackTitle() {
            let lastBreadCrumbIndex

            if (
                this.breadCrumb[this.breadCrumb.length - 3] &&
                this.breadCrumb[this.breadCrumb.length - 3].routeName !==
                    "Residences"
            ) {
                lastBreadCrumbIndex =
                    this.breadCrumb[this.breadCrumb.length - 3]
            } else {
                lastBreadCrumbIndex =
                    this.breadCrumb[this.breadCrumb.length - 2]
            }

            if (lastBreadCrumbIndex && lastBreadCrumbIndex.routeName) {
                switch (lastBreadCrumbIndex.routeName) {
                    case "Residence":
                        return this.$t("navigation.residenceBack")

                    case "Building":
                        return this.$t("navigation.buildingBack")

                    case "Stairwell": {
                        return this.$t("navigation.stairwellBack")
                    }
                    default:
                        return this.$t("navigation.back")
                }
            } else {
                return this.$t("navigation.back")
            }
        },
    },

    methods: {
        selectTab(value) {
            this.selectedTabs = value
            this.$emit("updateTab", value)
        },

        goBack() {
            this.$router.go(-1)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

p,
h1 {
    margin: 0;
}

.amazonKey-leftmenu-main-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
    width: 100%;
    height: 100%;
    max-width: 300px;
    background-color: $white;
    border-radius: 0 50px 0 0;
    box-shadow: 5px 5px 30px rgba($color: $grey-slate, $alpha: 0.3);

    @media all and (max-width: 1024px) {
        max-width: 50px;
        border-radius: 0 10px 0 0;
    }

    .amazonKey-goback-wrapper {
        padding: 30px 20px 0px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5em;
        width: 100%;
        transition: all 0.2s ease-in-out;

        @media all and (max-width: 1024px) {
            p {
                display: none;
            }
        }

        @media all and (min-width: 1024px) {
            i {
                transition: transform 0.2s ease-in-out;
            }
        }

        &:hover {
            cursor: pointer;
            color: $orange-neutral;
            transition: all 0.2s ease-in-out;

            @media all and (min-width: 1024px) {
                i {
                    transition: transform 0.2s ease-in-out;
                    transform: translateX(-8px);
                }
            }
        }
    }

    .amazonKey-infos-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3em;
        padding: 0px 20px;

        @media all and (max-width: 1024px) {
            display: none;
        }

        .amazonKey-name-wrapper {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: start;
            gap: 0.5em;

            i {
                color: $white;
                background-color: $orange-neutral;
                padding: 8px 10px;
                border-radius: 90px;
            }

            p {
                font-family: $font_avenir_heavy;
            }
        }
    }

    .tab-options-wrapper {
        display: flex;
        align-items: end;
        flex-direction: column;
        gap: 0.5em;
        padding: 30px 0 0 20px;

        @media all and (max-width: 1024px) {
            padding: 10px 0 0 10px;
        }

        .tab-options {
            width: 100%;
            max-width: 250px;
            padding: 15px 20px;
            transition: all 0.15s ease-in-out;
            border-radius: 10px 0 0 10px;
            display: flex;
            align-items: center;
            gap: 0.4em;
            font-family: $font_avenir_heavy;
            cursor: pointer;

            @media all and (max-width: 1024px) {
                padding: 1em 1em;
                p {
                    display: none;
                }
            }

            p,
            i {
                transition: all 0.15s ease-in-out;
            }

            &:hover {
                background-color: $grey-light;

                @media all and (min-width: 1024px) {
                    p,
                    i {
                        transform: translateX(20px);
                        transition: all 0.15s ease-in-out;
                        color: $orange-neutral;
                    }
                }
            }
        }

        .selected-tab {
            background-color: $grey-residence-dark;

            i {
                color: $orange-neutral;
            }

            p {
                color: $blue-neutral;
            }

            &:hover {
                background-color: $grey-residence-dark;
                cursor: default;

                p,
                i {
                    transform: translateX(0);
                }

                p {
                    color: $blue-neutral;
                }
            }
        }
    }
}
</style>
